import { useEffect } from "react";

function setMeta(name: string, content?: string) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Sets document title and description/keywords meta tags per page.
 */
export function usePageMeta(title: string, description?: string, keywords?: string) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    setMeta("description", description);
    setMeta("keywords", keywords);
  }, [title, description, keywords]);
}

export default usePageMeta;